import type { LevelKey } from "@/lib/people-levels";

export function initials(name: string | null, fallback: string): string {
  const source = name?.trim() || fallback;
  const letters = source
    .split(/[\s@.]+/)
    .map((w) => w.match(/\p{L}|\p{N}/u)?.[0] ?? "")
    .filter(Boolean);
  return letters.slice(0, 2).join("").toUpperCase();
}

const LEVEL_DOT: Record<LevelKey, string> = {
  owner: "bg-violet-500",
  admin: "bg-sky-500",
  standard: "bg-emerald-500",
  blocked: "bg-muted-foreground/40",
};

export function levelDot(key: LevelKey): string {
  return LEVEL_DOT[key];
}

